// AboutPage.js
'use client';
import { connect } from 'react-redux';

import { goBack } from 'redux-first-history';
import getMeData from '../selector/getMeData.js';
import AboutPage from '../page/AboutPage.jsx';

const mapStateToProps = state => {
  return {
    utm: getMeData(state, 'utm'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    close: () => dispatch(goBack()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AboutPage);
